interface QuizApiBaseUrlOptions {
  stage?: string;
  serverBaseUrl?: string;
  isBrowser?: boolean;
}

export function getQuizApiBaseUrl({
  stage,
  serverBaseUrl = '',
  isBrowser = typeof window !== 'undefined',
}: QuizApiBaseUrlOptions) {
  return isBrowser && (stage === 'LOC' || !stage)
    ? '/api/'
    : `${serverBaseUrl.replace(/\/$/, '')}/api/`;
}
